module.exports = __webpack_public_path__ + "static/media/voting.bd92ad21.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/voting.webm
// module id = 78
// module chunks = 0